import {
  PollVote,
  PollVoteCreateRequest,
} from "@virtualprogaming/js-public-sdk";
import { AxiosResponse } from "axios";
import { isFunction } from "lodash";
import { useMutation, UseMutationOptions, useQueryClient } from "react-query";

import { POLL_BY_ID } from "~/constants/react-query-keys/poll";

import { usePollApi } from "./usePollApi";

export function useCreateVote(
  options?: UseMutationOptions<
    AxiosResponse<PollVote>,
    unknown,
    [number, PollVoteCreateRequest]
  >
) {
  const api = usePollApi();
  const queryClient = useQueryClient();
  const { onSuccess, ...rest } = options || {};
  return useMutation((rq) => api.createVote(...rq), {
    onSuccess: async (data, vars, ctx) => {
      isFunction(onSuccess) && onSuccess(data, vars, ctx);
      await queryClient.invalidateQueries([POLL_BY_ID]);
    },
    ...rest,
  });
}
